import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PcapFile, PcapFilesSearchRequestParams } from '../types';
import { AxiosError, AxiosResponse } from 'axios';
import { downloadFile } from '@shared/utils/utilsOld';
import { RequestStatusEnum } from '@shared/types';

export type LibraryState = {
    pcapFiles: PcapFile[];
    getPcapFilesStatus: RequestStatusEnum;
    getPcapFilesError: PayloadAction<AxiosError> | null;
    pcapFilesCount: number;
    downloadPcapFileStatus: RequestStatusEnum;
    downloadPcapFileError: PayloadAction<AxiosError> | null;
};

const initialState: LibraryState = {
    pcapFiles: [],
    getPcapFilesStatus: RequestStatusEnum.NotRequested,
    getPcapFilesError: null,
    pcapFilesCount: 0,
    downloadPcapFileStatus: RequestStatusEnum.NotRequested,
    downloadPcapFileError: null,
};

const librarySlice = createSlice({
    name: '@library',
    initialState,
    reducers: {
        getPcapFilesRequest(state, _action: PayloadAction<PcapFilesSearchRequestParams>) {
            state.getPcapFilesStatus = RequestStatusEnum.Loading;

            state.getPcapFilesError = null;
        },
        getPcapFilesSuccess(state, action: PayloadAction<AxiosResponse>) {
            state.getPcapFilesStatus = RequestStatusEnum.Success;
            state.getPcapFilesError = null;
            state.pcapFiles = action.payload.data.items || [];
            state.pcapFilesCount = action.payload.data.count;
        },
        getPcapFilesError(state, action: PayloadAction<AxiosError>) {
            state.getPcapFilesStatus = RequestStatusEnum.Error;
            state.getPcapFilesError = action;
        },
        getPcapFilesReset(state) {
            state.getPcapFilesStatus = RequestStatusEnum.NotRequested;
            state.getPcapFilesError = null;
        },
        downloadPcapFileRequest(state, _action: PayloadAction<PcapFile['pk']>) {
            state.downloadPcapFileStatus = RequestStatusEnum.Loading;
            state.downloadPcapFileError = null;
        },
        downloadPcapFileSuccess(state, action: PayloadAction<AxiosResponse>) {
            state.downloadPcapFileStatus = RequestStatusEnum.Success;
            state.downloadPcapFileError = null;
            downloadFile(action.payload.data.download_url);
        },
        downloadPcapFileError(state, action: PayloadAction<AxiosError>) {
            state.downloadPcapFileStatus = RequestStatusEnum.Error;
            state.downloadPcapFileError = action;
        },
        downloadPcapFileReset(state) {
            state.downloadPcapFileStatus = RequestStatusEnum.NotRequested;
            state.downloadPcapFileError = null;
        },
    },
});

export default librarySlice.reducer;

export const {
    getPcapFilesRequest,
    getPcapFilesSuccess,
    getPcapFilesError,
    getPcapFilesReset,
    downloadPcapFileRequest,
    downloadPcapFileSuccess,
    downloadPcapFileError,
    downloadPcapFileReset,
} = librarySlice.actions;
